import type { SVGProps } from 'react';

export const MaestroLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            fill="white"
        />
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            stroke="#CCCCCC"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.8262 29.2975H35.1741V10.7021H24.8262V29.2975Z"
            fill="#7375CF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.483 20.0001C25.483 16.2276 27.2494 12.8676 30 10.7021C27.9885 9.11875 25.4502 8.17395 22.6914 8.17395C16.1604 8.17395 10.8662 13.4685 10.8662 20.0001C10.8662 26.5314 16.1604 31.826 22.6914 31.826C25.4502 31.826 27.9885 30.8812 30 29.2978C27.2494 27.1323 25.483 23.7723 25.483 20.0001Z"
            fill="#EB001B"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.7644 27.3281V26.8691H48.6445L48.5069 27.1848L48.3689 26.8691H48.249V27.3281H48.3338V26.9818L48.4629 27.2804H48.5506L48.68 26.9812V27.3281H48.7644ZM48.0056 27.3281V26.9473H48.159V26.8698H47.7681V26.9473H47.9215V27.3281H48.0056Z"
            fill="#00A2E5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.1338 20.0001C49.1338 26.5314 43.8396 31.826 37.3086 31.826C34.5498 31.826 32.0115 30.8812 30 29.2978C32.7506 27.1323 34.5169 23.7723 34.5169 20.0001C34.5169 16.2276 32.7506 12.8676 30 10.7021C32.0115 9.11875 34.5498 8.17395 37.3086 8.17395C43.8396 8.17395 49.1338 13.4685 49.1338 20.0001Z"
            fill="#00A2E5"
        />
    </svg>
);
